export class Sort {
  public label?: string;
  public sortKey: string;
  public ascending: boolean;

  constructor(sortKey?: string, ascending?: boolean) {
    this.sortKey = sortKey;
    this.ascending = ascending;
  }
}